Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AirtableForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var AirtableForm = function AirtableForm(_ref) {
  var airtableFormId = _ref.airtableFormId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "airtable-form",
    title: "airtable-".concat(airtableFormId),
    src: "https://airtable.com/embed/".concat(airtableFormId, "?backgroundColor=green"),
    width: "100%",
    height: "533",
    style: {
      background: 'transparent',
      border: '1px solid #ccc'
    },
    frameBorder: "0"
  })));
};
exports.AirtableForm = AirtableForm;